import React, { useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../ui/tabs';
import { HistoryTable } from './HistoryTable';
import CompanyMeetingsTab from './CompanyMeetingsTab';

const VENDOR_TABS = [
  { key: 'purchase_orders', label: 'Purchase Orders', columns: [
    { key: 'po_number', label: 'PO #' }, { key: 'order_date', label: 'Date' },
    { key: 'status', label: 'Status' }, { key: 'currency_code', label: 'Currency' }, { key: 'total', label: 'Total' },
  ] },
  { key: 'po_line_items', label: 'PO Line Items', columns: [
    { key: 'po_number', label: 'PO #' }, { key: 'order_date', label: 'Date' }, { key: 'sku', label: 'SKU' },
    { key: 'item_name', label: 'Item' }, { key: 'quantity', label: 'Qty' }, { key: 'rate', label: 'Rate' },
  ] },
  { key: 'offers', label: 'Offers', columns: [
    { key: 'offer_number', label: 'Offer #' }, { key: 'date_time', label: 'Date' }, { key: 'sku_code', label: 'SKU' },
    { key: 'qty_offered', label: 'Qty' }, { key: 'ask_price_usd', label: 'Ask Price' }, { key: 'status', label: 'Status' },
  ] },
  { key: 'purchases', label: 'Purchases', columns: [
    { key: 'date_time', label: 'Date' }, { key: 'sku_code', label: 'SKU' }, { key: 'qty', label: 'Qty' },
    { key: 'unit_price_usd', label: 'Unit Price' }, { key: 'status', label: 'Status' },
  ] },
];

const CUSTOMER_TABS = [
  { key: 'sales_orders', label: 'Sales Orders', columns: [
    { key: 'so_number', label: 'SO #' }, { key: 'order_date', label: 'Date' },
    { key: 'status', label: 'Status' }, { key: 'currency_code', label: 'Currency' }, { key: 'total', label: 'Total' },
  ] },
  { key: 'so_line_items', label: 'SO Line Items', columns: [
    { key: 'so_number', label: 'SO #' }, { key: 'order_date', label: 'Date' }, { key: 'sku', label: 'SKU' },
    { key: 'item_name', label: 'Item' }, { key: 'quantity', label: 'Qty' }, { key: 'rate', label: 'Rate' },
  ] },
];

export const DirectoryHistoryTabs = ({ type, data, meetingsCompanyType, meetingsCompanyRef }) => {
  const tabDefs = type === 'vendor' ? VENDOR_TABS : CUSTOMER_TABS;
  const [active, setActive] = useState(tabDefs[0].key);
  if (!data) return null;
  const showMeetings = !!meetingsCompanyType && !!meetingsCompanyRef;

  return (
    <Tabs value={active} onValueChange={setActive} data-testid="directory-history-tabs">
      <TabsList className="flex-wrap h-auto">
        {tabDefs.map(t => (
          <TabsTrigger key={t.key} value={t.key} data-testid={`history-tab-${t.key}`}>
            {t.label} ({(data[t.key] || []).length})
          </TabsTrigger>
        ))}
        {showMeetings && <TabsTrigger value="meetings" data-testid="history-tab-meetings">Meetings</TabsTrigger>}
      </TabsList>
      {tabDefs.map(t => (
        <TabsContent key={t.key} value={t.key}>
          <HistoryTable columns={t.columns} rows={data[t.key] || []} testId={`history-table-${t.key}`} />
        </TabsContent>
      ))}
      {showMeetings && (
        <TabsContent value="meetings">
          <CompanyMeetingsTab companyType={meetingsCompanyType} companyRef={meetingsCompanyRef} />
        </TabsContent>
      )}
    </Tabs>
  );
};
